import React from "react";
import {ButtonGroup, Button} from "react-bootstrap";

export const PAYOUT_SOURCE_FACIAL = "facial";
export const PAYOUT_SOURCE_MANUAL = "manual";

function PayoutSourceToggle({source, onChange, disabled = false}) {
    return (
        <ButtonGroup size="sm">
            <Button
                variant={source === PAYOUT_SOURCE_FACIAL ? "primary" : "outline-primary"}
                disabled={disabled}
                onClick={() => onChange(PAYOUT_SOURCE_FACIAL)}
            >
                Facial Device
            </Button>
            <Button
                variant={source === PAYOUT_SOURCE_MANUAL ? "primary" : "outline-primary"}
                disabled={disabled}
                onClick={() => onChange(PAYOUT_SOURCE_MANUAL)}
            >
                Manual Check-in/out
            </Button>
        </ButtonGroup>
    );
}

export default PayoutSourceToggle;
